import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { CostAccessGate } from '~/features/cost-estimate/components/cost-access-gate';
import { costApprovalsSearchSchema } from '~/features/cost-estimate/utils/cost-approvals-search';

// Not super-admin gated: approvers are an env list on workflow-service
// (GET /cost-estimates/approver-status), and the list endpoint scopes non-approvers to their
// own subsidiary, so the page is read-only for them. Amounts: `CostAccessGate` lets in lily.ai
// users and cost approvers once the server has answered.
const CostApprovalsPage = lazy(() => import('~/features/cost-estimate/pages/cost-approvals-page'));

/** Tab, History filter and page live in the URL so they survive Back and can be shared. */
export const Route = createFileRoute('/_authenticated/_tenant/cost-approvals')({
  validateSearch: costApprovalsSearchSchema,
  component: () => (
    <CostAccessGate>
      <Suspense fallback={<PageSkeleton />}>
        <CostApprovalsPage />
      </Suspense>
    </CostAccessGate>
  ),
});
